import Box from '@mui/material/Box';
import React from 'react';

import { FlowLane } from './FlowLane';
import { ServiceFlowRailProps } from './ServiceFlowRail.props';

/**
 * The flow rail — the home page's signature element.
 *
 * The ten job statuses are not a flat list. They describe a job flow (New →
 * Booking → Field Ready → OTW → On Site), a parts sub-flow that runs alongside
 * it (Parts Required → Processed → Logistics → Dispatched), and an exception
 * rail (Escalated). Rendering them as one segmented rail makes that structure
 * visible, so a bottleneck reads as a shape rather than as a number you have
 * to hunt for.
 *
 * Each lane is divided from the next by a rule; each stage drills through to
 * that status group across every client.
 */
export const ServiceFlowRail: React.FC<ServiceFlowRailProps> = ({
  lanes,
  canDrillDown,
  onStageSelect,
}) => (
  <Box
    component="section"
    aria-label="Service flow summary"
    sx={{
      display: 'flex',
      alignItems: 'stretch',
      gap: '10px',
      px: '6px',
      py: '8px',
      bgcolor: 'background.paper',
      border: 1,
      borderColor: 'v4.border',
      borderRadius: 2,
      overflowX: 'auto',
    }}
  >
    {lanes.map((lane, index) => (
      <React.Fragment key={lane.lane}>
        {index > 0 && (
          <Box aria-hidden sx={{ width: '1px', bgcolor: 'v4.border', flexShrink: 0, my: '2px' }} />
        )}
        <FlowLane
          lane={lane}
          canDrillDown={canDrillDown}
          onStageSelect={onStageSelect}
          flex={lane.stages.length}
        />
      </React.Fragment>
    ))}
  </Box>
);
